module.exports = __webpack_public_path__ + "img/logout-icon.cd2498f5.svg";